module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ9JREFUeNrsVosNgyAQpV2AbqAb4AiM4Ahu4giOoJvIBuoE2AnKBvSOYEO12MRPrA0veQlydzxP7kBCAgL+DZeFcREwtuMeeN/zJSkwB0qgHlFaG906YwYUwBtjjGRZRpIkMYa2bUlVVaTrOnxUQA7stsgURR+UUl3XtfYBbeiDvjZm9ec1ok3T6G9AH0ecrhHGfZtkKqXURVHosizNeJy53fd8jbCEPX1bGMXGxYVzLjDGFtziljGZuZl+qGhDN3OMsfORb/HrjLDp06F6EUIIr7Nrc2LiJcITKKU2OxTmhPuhTwekaep15py/xk5Mf6rimm0nFNuznQ47QHY7Mn/6kjj0Wjz0RyAg4Bx4CjAAK/mkyOdnmTAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/0.png
// module id = 755
// module chunks = 0